import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || (window.location.host.includes('dev') ? 'https://api.dev.aws.cinch.io' : 'https://engine.cinch.io');

export const getSurvey = (invite_id) => {
  return axios.get(`/surveys/invites/${invite_id}/start`);
}

export const getTestSurvey = (revision_id) => {
  return axios.get(`/surveys/revisions/${revision_id}/test`);
}

export const saveAnswer = (invite_id, question_id, answer) => {
  return axios.post(`/surveys/invites/${invite_id}/answer`, {
    question_id, answer
  });
}

export const updateAnswer = (invite_id, answer_id, answer) => {
  return axios.post(`/surveys/invites/${invite_id}/answer/${answer_id}`, {
    answer
  });
}
